import { Flex, Text } from "@radix-ui/themes";
import { isNull, isUndefined } from "lodash-es";
import { FC } from "react";

interface BooleanFieldRowProps {
  value?: boolean | null;
}

export const BooleanFieldRow: FC<BooleanFieldRowProps> = ({ value }) => {
  if (isNull(value) || isUndefined(value)) {
    return <div />;
  }

  return (
    <Flex align="center" justify="start" pl="1" pr="1">
      <Text size="1">{value ? "True" : "False"}</Text>
    </Flex>
  );
};
